<template>
  <button :class="`btn-note ${customClass}`" @click="handleClick">
    {{ content }}
  </button>
</template>

<script>
export default {
  name: "NoteButton",
  props: {
    content: {
      type: [Number, String],
      default: "",
    },
    propsHandleClick: {
      type: Function,
      default: null,
    },
    customClass: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleClick() {
      this.$emit("clickNoteButton");
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.btn-note {
  display: inline-block;
  vertical-align: top;
  min-width: 2rem;
  margin: 0;
  padding: 0.4rem 0.8rem 0.2rem;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: $light_yellow;
  border: 1px solid #fff;
  border-radius: 2em;
  box-shadow: 0 1px 2px rgba(#000, 0.5);
  transition: opacity 0.2s;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    opacity: 0.8;
  }

  &.disabled,
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}
</style>
